import React,{useState,useEffect, createContext, useContext} from 'react';
import Metadatas from './Metadatas';
import MintProgress from './MintProgress';

export const MintContext = createContext();

const Router = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [mintData, setMintData] = useState(null);
  
  const displayStep = () => {
    switch (currentStep) {
      case 0:
        return <Metadatas onNext={(data) => { setMintData(data); setCurrentStep(1); }} />;
      case 1:
        return <MintProgress mintData={mintData} />;
      default:
        return <Metadatas onNext={(data) => { setMintData(data); setCurrentStep(1); }} />;
    }
  }
  return (
    <MintContext.Provider value={{ mintData, setMintData, setCurrentStep }}>
    <div>
        {displayStep()}
    </div>
    </MintContext.Provider>
  )
};

export default Router;